import './LoadingScreen.css'

const LoadingScreen = () => {
  return (
    <div className="main-loading-screen">
      <div className="loading-content">
        {/* Presidio Logo */}
        <p>Data Trust Accelerator</p>
        {/* Loading Text */}
        <div className="loading-status-text">Loading ...</div>
      </div>
    </div>
  )
}

export default LoadingScreen
